
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LabourPriceListGrid extends Serenity.EntityGrid<LabourPriceListRow, any> {
        protected getColumnsKey() { return 'OMS.LabourPriceList'; }
        protected getDialogType() { return LabourPriceListDialog; }
        protected getIdProperty() { return LabourPriceListRow.idProperty; }
        protected getInsertPermission() { return LabourPriceListRow.insertPermission; }
        protected getLocalTextPrefix() { return LabourPriceListRow.localTextPrefix; }
        protected getService() { return LabourPriceListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}